// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "pickup_point_identifier": {
      "column": {
        "default": null,
        "name": "pickup_point_identifier",
        "null": true,
        "type": "string"
      },
      "name": "pickup_point_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "product_code": {
      "column": {
        "default": null,
        "name": "product_code",
        "null": false,
        "type": "string"
      },
      "name": "product_code",
      "selected_by_default": null,
      "translated": null
    },
    "shipment_template_identifier": {
      "column": {
        "default": null,
        "name": "shipment_template_identifier",
        "null": false,
        "type": "string"
      },
      "name": "shipment_template_identifier",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "OrderDeliveryShipmondo",
  "collectionKey": "order_delivery_shipmondos",
  "collectionName": "order_delivery_shipmondos",
  "i18nKey": "order_delivery_shipmondo",
  "camelizedLower": "orderDeliveryShipmondo",
  "name": "OrderDeliveryShipmondo",
  "nameDasherized": "order-delivery-shipmondo",
  "pluralName": "order_delivery_shipmondos",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "has_one",
      "resource_name": "Order",
      "through": "order_delivery"
    },
    {
      "className": "OrderDelivery",
      "collectionName": "order_deliveries",
      "foreignKey": "order_delivery_id",
      "name": "order_delivery",
      "macro": "belongs_to",
      "resource_name": "OrderDelivery",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "carrier_code",
      "column": {
        "default": null,
        "name": "carrier_code",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "order_delivery_id",
      "column": {
        "default": null,
        "name": "order_delivery_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "package_no",
      "column": {
        "default": null,
        "name": "package_no",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "pickup_point_identifier",
      "column": {
        "default": null,
        "name": "pickup_point_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "product_code",
      "column": {
        "default": null,
        "name": "product_code",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "shipment_draft_identifier",
      "column": {
        "default": null,
        "name": "shipment_draft_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "shipment_identifier",
      "column": {
        "default": null,
        "name": "shipment_identifier",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "shipment_template_identifier",
      "column": {
        "default": null,
        "name": "shipment_template_identifier",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "order_delivery_shipmondo",
  "primaryKey": "id"
}

/** Frontend model for OrderDeliveryShipmondo. */
export default class OrderDeliveryShipmondo extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  pickupPointIdentifier() {
    return this.readAttributeUnderscore("pickup_point_identifier")
  }

  /** @returns {boolean} */
  hasPickupPointIdentifier() {
    const value = this.pickupPointIdentifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  productCode() {
    return this.readAttributeUnderscore("product_code")
  }

  /** @returns {boolean} */
  hasProductCode() {
    const value = this.productCode()

    return this._isPresent(value)
  }

  /** @returns {string} */
  shipmentTemplateIdentifier() {
    return this.readAttributeUnderscore("shipment_template_identifier")
  }

  /** @returns {boolean} */
  hasShipmentTemplateIdentifier() {
    const value = this.shipmentTemplateIdentifier()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static pickupPoints(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "pickup_points",
        collectionName: "order_delivery_shipmondos",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static shipmentTemplates(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "shipment_templates",
        collectionName: "order_delivery_shipmondos",
        type: "collection"
      },
      commandArgs
    ))
  }
}
